module.exports = __webpack_public_path__ + "img/atd.f74bd036.jpg";